import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import {
    Theme,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    makeStyles
} from '@material-ui/core';

import DialogButton from '../../../Common/UI/Dialog/DialogButton';

import { MAIN_MAP } from '../../../../redux/map/Constants';
import { deleteDrawnFeatureAsync } from '../../../../redux/map/Actions';

interface Styles {
    deleteButton: React.CSSProperties;
    cancelButton: React.CSSProperties;
    textChange: React.CSSProperties;
    rootPadding: React.CSSProperties;
}

const propTypes = {};

const defaultProps = {};

const useStyles = makeStyles<Theme, object, keyof Styles>(() => styles() as Styles);

function DeleteSketchDialog({
    open,
    onClose,
    name,
    id
}: {
    readonly open: boolean;
    readonly onClose: any;
    readonly name: string;
    readonly id: number;
}): React.ReactElement {
    const classes = useStyles();
    const dispatch = useDispatch();

    const result = useSelector((state: any) => state[MAIN_MAP].savedDrawnFeatures);

    function dispatchDeleteDrawnFeatureAsync(id: number, name: string): any {
        return dispatch(deleteDrawnFeatureAsync(id, name, result));
    }

    function deleteSketch(id: number, name: string): any {
        dispatchDeleteDrawnFeatureAsync(id, name);
        onClose();
    }

    return (
        <Dialog open={open} onClose={onClose} fullWidth>
            <DialogTitle disableTypography>
                <Typography variant="h4">Delete Shape</Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Typography
                    variant="subtitle2"
                    classes={{
                        root: classes.textChange
                    }}>
                    {`Are you sure you want to delete '${name}' sketch? This process cannot be undone`}
                </Typography>
            </DialogContent>
            <DialogActions classes={{ root: classes.rootPadding }}>
                <DialogButton
                    variant="outlined"
                    classes={{ root: classes.cancelButton }}
                    onClick={onClose}>
                    Cancel
                </DialogButton>
                <DialogButton
                    variant="contained"
                    classes={{ root: classes.deleteButton }}
                    onClick={(): any => deleteSketch(id, name)}>
                    Delete
                </DialogButton>
            </DialogActions>
        </Dialog>
    );
}

const styles = (): any => ({
    cancelButton: {
        height: 40
    },
    deleteButton: {
        marginLeft: 24,
        height: 40,
        backgroundColor: '#FF7981'
    },
    textChange: {
        fontSize: 16,
        fontWeight: 300,
        lineHeight: '24px'
    },
    rootPadding: {
        padding: '20px 30px 24px 30px'
    }
});

DeleteSketchDialog.prototype = propTypes;
DeleteSketchDialog.defaultProps = defaultProps;

export default DeleteSketchDialog;
